import { orderDayCollection } from "@/firebase";

const state = {
  orderDay: {},
};

const getters = {};

const actions = {
  // eslint-disable-next-line
  getOrderDay({ commit }, payload) {
    orderDayCollection
      .where("client", "==", payload.client)
      .limit(1)
      .onSnapshot((snapshot) => {
        if (snapshot.empty) {
          commit("getOrderDay", {
            client: payload.client,
            orderNum: 0,
            totalCopies: 0,
            itemCopies: 0,
            totalSumCart: 0,
          });
        } else {
          let tempData = {};
          snapshot.docChanges().forEach(
            (change) => {
              tempData = Object.assign(change.doc.data(), {
                id: change.doc.id,
              });
              //console.log(tempData);
              if (change.type == "added") {
                //console.log("Day added.");
                commit("getOrderDay", tempData);
              } else if (change.type == "modified") {
                //console.log("Day modified.");
                commit("getOrderDay", tempData);
              } else if (change.type == "removed") {
                //console.log("Day deleted.");
                //commit("deleteRoom", tempData);
              }
            },
            (error) => {
              console.log(error);
            }
          );
        }
      });
  },
};

const mutations = {
  getOrderDay(state, payload) {
    state.orderDay = payload;
    //console.log(state.orderDay);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
